import React from "react";
import styled from "styled-components";
import colors from "../../util/colors";
import bgvideo from "../../Videos/bgvideo.mp4";
import bg from "../../Images/ultranewbg.jpg";

const HomeIntro = ({ language }) => {
  return (
    <StyledSection id="main-home" className="home-intro">
      {language === "EN" ? (
        <p>
          Bulilding Your Vision. <span>Creating Reality</span>
        </p>
      ) : (
        <p>
          نبني رؤيتك. <span>نصنع الواقع</span>
        </p>
      )}
      {/* <video src={bgvideo} autoPlay loop muted /> */}
      <div className="overlay"></div>
    </StyledSection>
  );
};
const StyledSection = styled.div`
  position: relative;
  font-family: "Arkibal Regular";
  height: calc(100vh - 8.85vw);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  p {
    z-index: 1000;
    font-size: 1.5vw;
    span {
      color: ${colors.green};
      font-family: "Arkibal Regular Italic";
    }
  }
  video {
    height: 100%;
    width: 100%;
    /* Achieving background attachment (fixed) */
    position: fixed;
    z-index: -1000;
    /* Achieving background attachment (fixed) */
    top: 0;
    left: 0;
    object-fit: cover;
    opacity: 0.8;
  }
  .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #3b3c41;
    mix-blend-mode: overlay;
  }
`;
export default HomeIntro;
